// Productpagina V1 (12-10-2026): pakketkeuze, aantal, toevoegen, galerij en sticky koopbalk.
// Toevoegen loopt via dezelfde route en hetzelfde event als product-form.js, zodat de winkelwagenlade opent.
import { CartAddEvent } from '@theme/events';

const root = document.querySelector('[data-sn-pdp]');

function readJson(selector) {
  try {
    return JSON.parse(root?.querySelector(selector)?.textContent || 'null');
  } catch (e) {
    return null;
  }
}

const variants = readJson('[data-sn-variants]') || [];
const strings = readJson('[data-sn-strings]') || {};

/* Toevoegen aan winkelwagen, voor het hoofdformulier en de kleine formulieren in "aanpak compleet". */
async function addToCart(form) {
  const button = form.querySelector('[data-sn-buy]') || form.querySelector('[type="submit"]');
  const error = form.querySelector('[data-sn-error]');
  if (button) button.setAttribute('aria-busy', 'true');
  if (error) error.hidden = true;

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  try {
    const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const data = await response.json();
    if (data.status) {
      if (error) {
        error.textContent = data.description || data.message || strings.error || '';
        error.hidden = false;
      }
      return;
    }
    form.dispatchEvent(
      new CartAddEvent({}, String(formData.get('id')), {
        source: 'product-form-component',
        itemCount: Number(formData.get('quantity')) || 1,
        productId: form.querySelector('[name="product-id"]')?.value,
        sections: data.sections,
      })
    );
  } catch (e) {
    if (error) {
      error.textContent = strings.error || '';
      error.hidden = false;
    }
  } finally {
    if (button) button.removeAttribute('aria-busy');
  }
}

document.querySelectorAll('form[data-sn-form]').forEach((form) => {
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    addToCart(form);
  });
});

if (root) {
  const form = root.querySelector('#sn-pdp-form');
  const buyButton = root.querySelector('[data-sn-buy]');
  const buyText = root.querySelector('[data-sn-buy-text]');
  const priceEl = root.querySelector('[data-sn-price]');
  const unitEl = root.querySelector('[data-sn-unit]');
  const stock = root.querySelector('[data-sn-stock]');
  const stockText = root.querySelector('[data-sn-stock-text]');
  const sticky = root.querySelector('[data-sn-sticky]');
  const stickyMeta = root.querySelector('[data-sn-sticky-meta]');
  const stickyPrice = root.querySelector('[data-sn-sticky-price]');
  const stickyBuy = root.querySelector('[data-sn-sticky-buy]');
  const qtyInput = root.querySelector('[data-sn-qty-input]');

  /* "excl. verzendkosten": open de vraag over verzending in de FAQ */
  root.querySelector('[data-sn-shiplink]')?.addEventListener('click', () => {
    const faq = document.getElementById('sn-faq-verzending');
    if (faq) faq.open = true;
  });

  /* Aantal */
  root.querySelectorAll('[data-sn-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const step = Number(btn.getAttribute('data-sn-qty'));
      const next = Math.min(99, Math.max(1, (Number(qtyInput.value) || 1) + step));
      qtyInput.value = String(next);
    });
  });

  /* Pakketkeuze (varianten van dit product) */
  function applyVariant(variant) {
    if (!variant) return;
    if (priceEl) priceEl.innerHTML = variant.priceHtml || variant.price;
    const compare = root.querySelector('[data-sn-compare]');
    if (compare) {
      compare.textContent = variant.compare || '';
      compare.hidden = !variant.compare;
    }
    if (unitEl) unitEl.textContent = variant.unit || '';
    const packEl = root.querySelector('[data-sn-packname]');
    if (packEl) packEl.textContent = variant.pack || '';
    const baseEl = root.querySelector('[data-sn-base]');
    if (baseEl && variant.base) baseEl.textContent = variant.base;
    if (buyButton) buyButton.disabled = !variant.available;
    if (stickyBuy) stickyBuy.disabled = !variant.available;
    if (buyText) buyText.textContent = variant.available ? strings.add : strings.soldOut;
    if (stock) stock.classList.toggle('sn-buy__stock--out', !variant.available);
    if (stockText) stockText.textContent = variant.available ? strings.inStock : strings.soldOut;
    if (stickyPrice) stickyPrice.textContent = variant.price;
    if (stickyMeta) {
      const state = (variant.available ? strings.inStock : strings.soldOut || '').toLowerCase();
      stickyMeta.textContent = strings.onlyDefault ? state : `${variant.title} · ${state}`;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variant.id));
    window.history.replaceState({}, '', url.toString());
    if (variant.media) goToMedia(variant.media);
  }

  root.querySelectorAll('[data-sn-variant]').forEach((input) => {
    input.addEventListener('change', () => {
      applyVariant(variants.find((v) => String(v.id) === input.value));
    });
  });

  /* Galerij: miniaturen, swipe en streepjes */
  const track = root.querySelector('[data-sn-track]');
  const thumbs = [...root.querySelectorAll('[data-sn-thumb]')];
  const dots = [...root.querySelectorAll('.sn-gallery__dots span')];
  const slides = [...root.querySelectorAll('[data-sn-slide]')];

  const navs = [...root.querySelectorAll('[data-sn-step]')];

  function setActive(index) {
    thumbs.forEach((t, i) => (i === index ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
    dots.forEach((d, i) => d.toggleAttribute('data-active', i === index));
    navs.forEach((n) => { n.disabled = Number(n.dataset.snStep) < 0 ? index === 0 : index === slides.length - 1; });
    // Alleen de miniaturenstrook zelf scrollen, niet de pagina (scrollIntoView verschuift ook het venster).
    const thumb = thumbs[index];
    const strip = thumb && thumb.closest('.sn-gallery__thumbs');
    if (strip && strip.offsetParent) {
      const t = thumb.getBoundingClientRect();
      const s = strip.getBoundingClientRect();
      if (t.left < s.left) strip.scrollLeft -= s.left - t.left;
      else if (t.right > s.right) strip.scrollLeft += t.right - s.right;
      if (t.top < s.top) strip.scrollTop -= s.top - t.top;
      else if (t.bottom > s.bottom) strip.scrollTop += t.bottom - s.bottom;
    }
  }

  function goTo(index, smooth = true) {
    const slide = slides[index];
    if (!track || !slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
    setActive(index);
  }

  function goToMedia(mediaId) {
    const index = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
    if (index > -1) goTo(index);
  }

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.snThumb))));

  if (track && slides.length > 1) {
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(slides.length - 1, index)));
        slides.forEach((s, i) => {
          if (i !== index) s.querySelectorAll('video').forEach((v) => v.pause());
        });
      });
    });
    track.addEventListener('keydown', (event) => {
      const current = Math.round(track.scrollLeft / track.clientWidth);
      if (event.key === 'ArrowRight') goTo(Math.min(slides.length - 1, current + 1));
      if (event.key === 'ArrowLeft') goTo(Math.max(0, current - 1));
    });

    /* Pijlen op de hoofdfoto (desktop) */
    navs.forEach((nav) => nav.addEventListener('click', () => {
      const current = Math.round(track.scrollLeft / track.clientWidth);
      goTo(Math.max(0, Math.min(slides.length - 1, current + Number(nav.dataset.snStep))));
    }));

    /* Slepen met de muis (desktop): de foto volgt de muis en springt bij loslaten naar de dichtstbijzijnde foto,
       vanaf een vijfde van de breedte naar de volgende. Aanraken en trackpad scrollen gewoon zelf. */
    let drag = null;
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: track.scrollLeft, start: Math.round(track.scrollLeft / track.clientWidth), moved: false };
    });
    track.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 8) {
        drag.moved = true;
        try { track.setPointerCapture(event.pointerId); } catch (e) { /* aanwijzer al los */ }
        track.classList.add('is-dragging');
      }
      if (drag.moved) track.scrollLeft = drag.left - dx;
    });
    const endDrag = (event) => {
      if (!drag) return;
      const { moved, start, x } = drag;
      drag = null;
      if (!moved) return;
      track.classList.remove('is-dragging');
      const dx = event.clientX - x;
      const step = Math.abs(dx) > track.clientWidth / 5 ? (dx < 0 ? 1 : -1) : 0;
      goTo(Math.max(0, Math.min(slides.length - 1, start + step)));
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }

  /* Variant uit de URL (?variant=, ook de Offer-URL in de structured data): galerij direct op de foto van die variant */
  const urlVariant = new URL(window.location.href).searchParams.get('variant');
  const preselected = urlVariant && variants.find((v) => String(v.id) === urlVariant);
  if (preselected && preselected.media) {
    const index = slides.findIndex((s) => s.dataset.mediaId === String(preselected.media));
    if (index > 0) goTo(index, false);
  }

  /* Fotogalerij op volledig scherm: klik of tik op een productfoto; kruisje, pijlen, swipen, pijltoetsen en Esc. */
  const lightbox = root.querySelector('[data-sn-lightbox]');
  if (lightbox && typeof lightbox.showModal === 'function') {
    const lbTrack = lightbox.querySelector('[data-sn-lb-track]');
    const lbSlides = [...lightbox.querySelectorAll('.sn-lightbox__slide')];
    const lbCount = lightbox.querySelector('[data-sn-lb-count]');
    const lbIndex = () => Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
    const lbGo = (index, smooth = true) => {
      const i = Math.max(0, Math.min(lbSlides.length - 1, index));
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      if (lbCount) lbCount.textContent = String(i + 1);
    };
    let downX = null;
    track?.addEventListener('pointerdown', (event) => { downX = event.clientX; });
    track?.addEventListener('click', (event) => {
      // Een swipe in de galerij is geen klik: alleen openen bij (vrijwel) stilstaande aanwijzer.
      if (downX !== null && Math.abs(event.clientX - downX) > 8) return;
      const slide = event.target.closest('[data-sn-zoom]');
      if (!slide) return;
      lightbox.showModal();
      requestAnimationFrame(() => lbGo(Number(slide.dataset.snZoom), false));
    });
    lightbox.querySelector('[data-sn-lb-close]')?.addEventListener('click', () => lightbox.close());
    lightbox.querySelectorAll('[data-sn-lb-step]').forEach((btn) => {
      btn.addEventListener('click', () => lbGo(lbIndex() + Number(btn.dataset.snLbStep)));
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') lbGo(lbIndex() + 1);
      if (event.key === 'ArrowLeft') lbGo(lbIndex() - 1);
    });
    let lbRaf = 0;
    lbTrack.addEventListener('scroll', () => {
      cancelAnimationFrame(lbRaf);
      lbRaf = requestAnimationFrame(() => { if (lbCount) lbCount.textContent = String(lbIndex() + 1); });
    });
    // Klik naast de foto (op de witte achtergrond) sluit ook.
    lightbox.addEventListener('click', (event) => {
      if (event.target.classList.contains('sn-lightbox__slide')) lightbox.close();
    });
  }

  /* Sticky koopbalk: zichtbaar als de koopknop uit beeld is, erboven of (sinds 03-11-2026) nog eronder (CSS toont hem alleen op mobiel).
     Eronder pas als ook de pakketkeuze nog helemaal onder het scherm zit, anders dekt de balk de kaarten af. */
  if (sticky && buyButton) {
    const buyStart = root.querySelector('.sn-packs') || buyButton;
    const update = () => {
      const rect = buyButton.getBoundingClientRect();
      const show = rect.bottom < 0 || buyStart.getBoundingClientRect().top > window.innerHeight;
      if (show === sticky.hasAttribute('data-visible')) return;
      sticky.toggleAttribute('data-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBuy) stickyBuy.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  if (stickyBuy && form) {
    stickyBuy.addEventListener('click', () => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else addToCart(form);
    });
  }
}
